module.exports = __webpack_public_path__ + "img/sex-and-libido.5003b59f.svg";